import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../helpers/common'
import { register } from '../../../helpers/reducerRegistry'
import { ALERT_SETTING_SLICE_NAME } from './../constant'
import {
  getAlertSettingsDynamic,
  updateAlertSettings,
  updateProfileSendEmail,
} from './thunk'

const initialState = {
  settings: {},

  profileIds: [],
  customProfileIds: [],
  profileById: {},
  customProfileList: [],
  checkedProfileIds: {},
  allExistNames: [],
  loading: {
    settings: true,
    updateSettings: false,
    profileDetail: false,
  },
}

export const slice = createSlice({
  name: ALERT_SETTING_SLICE_NAME,
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeCheckedProfileIds: (state, action) => {
      state.checkedProfileIds = {
        ...state.checkedProfileIds,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    // updateAlertSettings
    builder.addCase(updateAlertSettings.pending, (state) => {
      state.loading.updateSettings = true
    })
    builder.addCase(updateAlertSettings.fulfilled, (state, action) => {
      state.settings = { ...state.settings, ...action.meta.arg }
      state.loading.updateSettings = false
    })
    builder.addCase(updateAlertSettings.rejected, (state, action) => {
      state.loading.updateSettings = action.payload.loading
    })
    // updateProfileSendEmail
    builder.addCase(updateProfileSendEmail.pending, (state) => {
      state.loading.updateSettings = true
    })
    builder.addCase(updateProfileSendEmail.fulfilled, (state, action) => {
      const { alertProfileId, enableEmail } = action.meta.arg
      state.profileById = {
        ...state.profileById,
        [alertProfileId]: {
          ...state.profileById[alertProfileId],
          enableEmail: enableEmail,
        },
      }
      state.loading.updateSettings = false
    })
    builder.addCase(updateProfileSendEmail.rejected, (state, action) => {
      state.loading.updateSettings = action.payload.loading
    })
    //DYNAMIC
    //getAlertSettingsDynamic
    builder.addCase(getAlertSettingsDynamic.pending, (state) => {
      state.loading.settings = true
    })
    builder.addCase(getAlertSettingsDynamic.fulfilled, (state, { payload }) => {
      const profiles = payload?.alertProfiles
        ? payload?.alertProfiles.map((item) => ({
            ...item,
            isDefaultProfile: item?.isDefault,
          }))
        : []
      const profileIds = []
      const customProfileIds = []
      const customProfiles = []

      profiles.forEach((item) => {
        profileIds.push(item.alertProfileId)
        if (!item.isDefault) {
          customProfileIds.push(item.alertProfileId)
          customProfiles.push(item)
        }
      })
      state.settings = payload || initialState.settings
      state.profileIds = profileIds
      state.customProfileIds = customProfileIds
      state.profileById = keyBy(profiles, 'alertProfileId')
      state.customProfileList = customProfiles
      state.allExistNames = profiles.map((item) => item.profileName)
      state.loading.settings = false
    })
    builder.addCase(getAlertSettingsDynamic.rejected, (state, action) => {
      state.loading.settings = action.payload.loading
    })
  },
})

export const selectSettings = (key, callback) => (state) => {
  const settings = state[slice.name].settings
  const data = key ? settings[key] : settings
  return callback ? callback(data) : data
}

export const selectProfileIds = (state) => state[slice.name].profileIds
export const selectCustomProfileList = (state) =>
  state[slice.name].customProfileList
export const selectCustomProfileIds = (state) =>
  state[slice.name].customProfileIds
export const selectProfileById = (id, attr) => (state) => {
  const data = state[slice.name].profileById
  if (!id) return data
  if (!attr) return data[id]
  return data[id]?.[attr]
}
export const selectAllExistNames = (state) => state[slice.name].allExistNames

export const selectCheckedProfileIds = (key, callback) => (state) => {
  const checkedProfileIds = state[slice.name].checkedProfileIds
  const data = key ? checkedProfileIds[key] : checkedProfileIds
  return callback ? callback(data) : data
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return state[slice.name].loading[type]
}

export const { resetStore, changeCheckedProfileIds } = slice.actions

register(slice.name, slice.reducer)
